import * as types from '../actions/actionTypes';

const blogReducerDefaultState = [
    {
        id: '',
        author: 'blog author',
        comments: [],
        content: 'blog content',
        date: '',
        name: 'blog name',
        summary: 'blog summary',
        language: 'en'
    }
];

export default function blogReducer(state = blogReducerDefaultState, action) {
    const { blog, blogs, blogId } = action;
    switch (action.type) {
        case types.GET_ALL_BLOGS:
            return [...blogs];
        case types.ADD_NEW_BLOG:
            return [...state, blog];
        case types.DELETE_BLOG:
            return state.filter(({ id }) => id !== blogId);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/blogs.js